
/* Loads a script */
function loadScript(src) {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.body.appendChild(s);
  });
}

/* global DetailsDisclosure, trapFocus, removeTrapFocus */
if (!customElements.get('cart-drawer-disclosure')) {
  class CartDrawerDisclosure extends DetailsDisclosure {
    constructor() {
      super();
      this.openBtn = this.querySelector('summary');
      this.closeBtn = this.querySelector('.js-close');
      this.overlay = document.getElementById('cart-drawer').querySelector('.overlay');
    }

    handleClick(evt) {
      if (!evt.target.matches('.js-close')) return;
      this.close();
    }

    open() {
      this.overlay.classList.add('is-visible');
      super.open();
      trapFocus(this);

      this.clickHandler = this.clickHandler || this.handleClick.bind(this);
      this.keyupHandler = (evt) => evt.key === 'Escape' && this.close();

      this.addEventListener('click', this.clickHandler);
      this.addEventListener('keyup', this.keyupHandler);
      this.overlay.addEventListener('click', this.clickHandler);
    }

    close() {
      this.overlay.classList.remove('is-visible');
      super.close();
      removeTrapFocus(this.openBtn);

      this.removeEventListener('click', this.clickHandler);
      this.removeEventListener('keyup', this.keyupHandler);
      this.overlay.removeEventListener('click', this.clickHandler);
    }
  }

  customElements.define('cart-drawer-disclosure', CartDrawerDisclosure);
}

/* global SideDrawer */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends SideDrawer {
    constructor() {
      super();

      this.cartSummary = this.querySelector('.cart-drawer__summary');
      this.init();
      this.bindEvents();

      // Custom remove logic
      this.bindRemoveByIds();

      // Coupon form
      this.initCouponForm();

      // Specific product toggle logic
      this.initSpecificProductEvent();
    }

    disconnectedCallback() {
      document.removeEventListener('dispatch:cart-drawer:refresh', this.refreshHandler);
      document.removeEventListener('on:bfcache:load-restore', this.refreshHandler);
      document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
      document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);

      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:select', this.sectionSelectHandler);
        document.removeEventListener('shopify:section:deselect', this.sectionDeselectHandler);
      }

      if (this.dcbLoadedHandler) {
        document.removeEventListener('shopify:payment_button:loaded', this.dcbLoadedHandler);
      }
    }

    init() {
      const cartIcon = document.getElementById('cart-icon');
      if (cartIcon) {
        cartIcon.setAttribute('role', 'button');
        cartIcon.setAttribute('aria-haspopup', 'dialog');

        cartIcon.addEventListener('click', (evt) => {
          evt.preventDefault();
          this.open(cartIcon);
        });

        cartIcon.addEventListener('keydown', (evt) => {
          if (evt.key !== ' ') return;
          evt.preventDefault();
          this.open(cartIcon);
        });
      }
    }

    bindEvents() {
      if (Shopify.designMode) {
        this.sectionSelectHandler = this.handleSectionSelect.bind(this);
        this.sectionDeselectHandler = this.handleSectionDeselect.bind(this);
        document.addEventListener('shopify:section:select', this.sectionSelectHandler);
        document.addEventListener('shopify:section:deselect', this.sectionDeselectHandler);
      }

      this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
      this.closeDrawerViaEventHandler = this.close.bind(this, null);
      document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
      document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);

      if (this.cartSummary.classList.contains('cart-drawer--checkout--sticky-true')) {
        this.dcbLoadedHandler = this.dcbLoadedHandler || CartDrawer.recalculateCssVarHeights;
        document.addEventListener('shopify:payment_button:loaded', this.dcbLoadedHandler);
      }

      this.refreshHandler = this.refresh.bind(this);
      document.addEventListener('dispatch:cart-drawer:refresh', this.refreshHandler);
      document.addEventListener('on:bfcache:load-restore', this.refreshHandler);
    }

    // ------------------ REMOVE BY ID ------------------
    bindRemoveByIds() {

async function checkAndRemoveSpecificProduct() {
 
  const specificVariantId = 46692864065836;

 
   try {
    const response = await fetch('/cart.js?timestamp=' + Date.now(), {
      cache: 'no-store'
    });
    const cart = await response.json();

    if (!cart.items || cart.items.length === 0) return;

    const specificProduct = cart.items.find(
      i => i.id === specificVariantId
    );

    if (specificProduct && cart.items.length === 1) {
      console.log("Auto-removing specific product.");

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [specificProduct.key]: 0 }
        })
      });

      document.dispatchEvent(
        new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })
      );
    }
  } catch (err) {
    console.error("Error in specific removal:", err);
  }
}


  // document.addEventListener("click", async (e) => {
  //   const btn = e.target.closest("[data-id-to-remove]");
  //   if (!btn) return;

  //   e.preventDefault();
  //   e.stopImmediatePropagation();

  //   const parentSelector = btn.getAttribute("data-target-parent");
  //   const parentEl = parentSelector ? document.querySelector(parentSelector) : null;

  //   if (parentEl) {
  //     parentEl.classList.add("pointer-events-none");
  //     parentEl.style.opacity = "0.3";
  //     const loader = parentEl.querySelector(".cart-item__loader");
  //     if (loader) loader.hidden = false;
  //   }

  //   let idsToRemove = (btn.getAttribute("data-id-to-remove") || "")
  //     .split(",")
  //     .map(id => id.trim())
  //     .filter(Boolean);

  //   try {
  //     // Fetch latest cart without caching
  //     const cart = await fetch(`/cart.js?ts=${Date.now()}`, { cache: "no-store" })
  //       .then(res => res.json());

  //     const updates = {};

  //     cart.items.forEach(item => {
  //       // Remove selected variants
  //       if (idsToRemove.includes(item.variant_id.toString())) {
  //         updates[item.key] = 0;
  //       }

  //     });

  //     // If no updates needed, skip API call
  //     if (Object.keys(updates).length) {
  //       await fetch("/cart/update.js", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ updates })
  //       });
  //     }

  //     document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true }));

  //   } catch (err) {
  //     console.error("Cart removal error:", err);
  //   } finally {
  //     if (parentEl) {
  //       parentEl.classList.remove("pointer-events-none");
  //       parentEl.style.opacity = "1";
  //       const loader = parentEl.querySelector(".cart-item__loader");
  //       if (loader) loader.hidden = true;
  //     }
  //     setTimeout(() => {
  //       checkAndRemoveSpecificProduct();
  //     }, 300);
  //   }
  // });






  // ============= remove based on group ===================
document.addEventListener(
  "click",
  async (e) => {
    const btn = e.target.closest("[data-item-group-id-to-remove]");
    if (!btn) return;

    console.group();
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    // Safety: ensure button does not submit form
    if (btn.tagName === "BUTTON") {
      btn.setAttribute("type", "button");
    }

    const groupId = btn.dataset.itemGroupIdToRemove;

    const parentSelector = btn.getAttribute("data-target-parent");
    const parentEl = parentSelector
      ? document.querySelector(parentSelector)
      : null;

    if (parentEl) {
      parentEl.classList.add("pointer-events-none");
      parentEl.style.opacity = "0.3";
      const loader = parentEl.querySelector(".cart-item__loader");
      if (loader) loader.hidden = false;
    }

    try {
      const cart = await fetch(`/cart.js?ts=${Date.now()}`, {
        cache: "no-store",
      }).then((res) => res.json());

      const updates = {};

      cart.items.forEach((item, index) => {
        const itemGroupId =
          item.properties?.Group_ID ||
          item.properties?._item_group_id ||
          item.properties?.item_group_id ||
          item.properties?._bundle_id;

        if (
          itemGroupId &&
          itemGroupId.toString() === groupId.toString()
        ) {
          updates[item.key] = 0;
        } else {
          console.log("❌ No match");
        }

        console.groupEnd();
      });

      if (Object.keys(updates).length === 0) {
        console.warn(
          "⚠ No matching items found for this group ID. Nothing will be removed."
        );
      } else {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        });
      }

      document.dispatchEvent(
        new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true })
      );

    } catch (err) {
      console.error("❌ GROUP REMOVE ERROR:", err);
    } finally {
      if (parentEl) {
        parentEl.classList.remove("pointer-events-none");
        parentEl.style.opacity = "1";
        const loader = parentEl.querySelector(".cart-item__loader");
        if (loader) loader.hidden = true;
      }
      checkAndRemoveSpecificProduct();
      console.groupEnd();
    }
  },
  true
);
  // ============= remove based on group ===================
// ======== BYO quantitiy update code =========
document.addEventListener(
  "click",
  async (e) => {
    const btn = e.target.closest("[data-group-to-update-qty]");
    if (!btn) return;

    console.group("🔢 QUANTITY BUTTON CLICK");

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const groupId = btn.dataset.groupToUpdateQty;
    const isPlus = btn.name === "plus";
    const isMinus = btn.name === "minus";

    if (!isPlus && !isMinus) {
      console.warn("⚠ Button is neither plus nor minus, ignoring");
      return;
    }

    // Find the input field in the same quantity group
    const qtyInput = btn.closest("quantity-input-group").querySelector("input.qty-input__input");
    if (!qtyInput) {
      console.error("❌ Quantity input not found");
      return;
    }

    let currentQty = parseInt(qtyInput.value, 10) || 0;
    const newQty = isPlus ? currentQty + 1 : currentQty - 1;

    // UI loader / opacity
    const parentEl = btn.closest("quantity-input-group");
    if (parentEl) {
      parentEl.classList.add("pointer-events-none");
      parentEl.style.opacity = "0.3";
    }

    try {
      const cart = await fetch(`/cart.js?ts=${Date.now()}`, { cache: "no-store" }).then(res => res.json());
      const updates = {};

      cart.items.forEach(item => {
        const itemGroupId =
          item.properties?.Group_ID ||
          item.properties?._item_group_id ||
          item.properties?.item_group_id ||
          item.properties?._bundle_id;

        if (itemGroupId && itemGroupId.toString() === groupId.toString()) {
          if (newQty <= 0) {
            updates[item.key] = 0; // remove if quantity goes to 0
          } else {
            updates[item.key] = newQty; // update quantity
          }
        }
      });

      if (Object.keys(updates).length) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        });
      } else {
        console.warn("⚠ No items matched this group ID");
      }

      // Update input field visually
      qtyInput.value = Math.max(newQty, 0);

      document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true }));

    } catch (err) {
      console.error("❌ Quantity update error:", err);
    } finally {
      if (parentEl) {
        parentEl.classList.remove("pointer-events-none");
        parentEl.style.opacity = "1";
      }
      console.groupEnd();
    }
  },
  true // capture phase to stop other listeners
);

// ======== BYO quantitiy update code =========












}


    // ------------------ COUPON FORM ------------------
    initCouponForm() {
      const couponInput = this.querySelector('input[name="custom-discount-input"]');
      const couponApply = this.querySelector('.submit-discount');
      const couponError = this.querySelector('.custom-discount-form .error');
      const couponRemove = this.querySelectorAll('.remove-discount');

      if (couponError) couponError.style.display = 'none';

      if (couponApply && couponInput) {
        couponApply.addEventListener('click', async (e) => {
          e.preventDefault();

          const code = couponInput.value.trim();
          if (!code) {
            if (couponError) {
              couponError.innerText = 'Please enter a discount code';
              couponError.style.display = 'block';
            }
            return;
          }

          couponApply.disabled = true;
          const oldText = couponApply.innerText;
          couponApply.innerText = 'Applying...';
          if (couponError) couponError.style.display = 'none';

          try {
            const res = await fetch(`/discount/${encodeURIComponent(code)}`, { method: 'GET' });
            if (!res.ok && couponError) {
              couponError.innerText = 'Invalid discount code';
              couponError.style.display = 'block';
            }

            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          } catch (err) {
            console.error('Coupon apply error:', err);
            if (couponError) {
              couponError.innerText = 'Something went wrong, try again';
              couponError.style.display = 'block';
            }
          } finally {
            couponApply.disabled = false;
            couponApply.innerText = oldText;
          }
        });
      }

      if (couponRemove.length > 0) {
        couponRemove.forEach((btn) => {
          btn.addEventListener('click', async (e) => {
            e.preventDefault();
            btn.disabled = true;
            const oldHtml = btn.innerHTML;
            btn.innerHTML = '...';

            try {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: '' })
              });
              document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
            } catch (err) {
              console.error('Coupon remove error:', err);
            } finally {
              btn.disabled = false;
              btn.innerHTML = oldHtml;
            }
          });
        });
      }
    }

    //------------------ SPECIFIC PRODUCT TOGGLE ------------------
   initSpecificProductEvent() {
  document.addEventListener('DOMContentLoaded', function() {
  


  const specificVariantId = 46692864065836; // Replace with your specific variant ID

  async function refreshCheckoutButton() {
  try {
    const response = await fetch("/cart.js?timestamp=" + Date.now(), { cache: "no-store" });
    const cart = await response.json();

    const checkoutBtn = document.querySelector('button[name="checkout"]');

    if (checkoutBtn) {
      const formatted = Shopify.formatMoney(cart.total_price);
     
      checkoutBtn.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon">
          <path d="M12 2c2.761 0 5 2.089 5 4.667V8h2.2a.79.79 0 0 1 .8.778v12.444a.79.79 0 0 1-.8.778H4.8a.789.789 0 0 1-.8-.778V8.778A.79.79 0 0 1 4.8 8H7V6.667C7 4.09 9.239 2 12 2zm6.4 7.556H5.6v10.888h12.8V9.556zm-6.4-6c-1.84 0-3.333 1.392-3.333 3.11V8h6.666V6.667c0-1.719-1.492-3.111-3.333-3.111z"></path>
        </svg>
        Checkout – ${formatted}
      `;
 
    }

  } catch (err) {
    console.error("Error refreshing checkout button:", err);
  }
  }


  // Helper: Fetch current cart
  async function fetchCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  // Helper: Add product to cart
  async function addProduct(variantId, quantity = 1) {
    
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    refreshCheckoutButton();
   setTimeout(function() {
    const toggleBtnn = document.querySelector(".toggle_button_atc");
  
    // Ensure the button is found before trying to add a class
    if (toggleBtnn) {
        toggleBtnn.classList.add("active");
    }
  }, 1000);
  }


 async function removeSpecificProduct() {
 
  try {
    // Directly fetch cart and locate product
    const response = await fetch("/cart.js?timestamp=" + Date.now(), { cache: "no-store" });
    const cart = await response.json();

    const item = cart.items.find(i => i.id === specificVariantId);
    if (!item) return;

    // Remove product directly
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: { [item.key]: 0 } }),
    });
    refreshCheckoutButton();
    // document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    setTimeout(() => {
      document.querySelector(".toggle_button_atc").classList.remove("active");
    }, 1000);

  } catch (err) {
    console.error("Error removing specific product:", err);
  }
  }



  // Helper: Update quantity
  async function updateProductQuantity(lineKey, quantity) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [lineKey]: quantity } })
    });
  }

  // Core logic: Ensure product is in cart with only 1 quantity
  async function ensureSpecificProductInCart() {

  try {
    const response = await fetch("/cart.js?timestamp=" + Date.now(), { cache: "no-store" });
    const cart = await response.json();

    const existingItem = cart.items.find(item => item.id === specificVariantId);

    if (existingItem) {
   
      if (existingItem.quantity !== 1) {
        await updateProductQuantity(existingItem.key, 1);
      }
      setTimeout(() => {
      const toggleBtnn = document.querySelector(".toggle_button_atc");

    // Ensure the button is found before trying to add a class
    if (toggleBtnn) {
        toggleBtnn.classList.add("active");
    }
      }, 1000);
      
    } else {
     
      await addProduct(specificVariantId, 1);
    }
  } catch (error) {
    console.error("Error managing specific product:", error);
  }
}


async function initToggleButtonHandler() {
  const toggleButton = document.querySelector(".toggle_button_atc");

  // HARD GUARD — required
  if (!toggleButton) {
    console.warn("toggle_button_atc not found");
    return;
  }

  // Prevent duplicate event binding
  if (toggleButton.dataset.bound === "true") return;
  toggleButton.dataset.bound = "true";

  toggleButton.addEventListener("click", async () => {
    if (toggleButton.classList.contains("active")) {
      removeSpecificProduct();
    } else {
      await ensureSpecificProductInCart();
    }
  });
}





// Delay execution to ensure DOM elements are available
setTimeout(() => {
  initToggleButtonHandler();
}, 2000);


 

   // Define your function
async function loopProductInCart() {

  try {
    const response = await fetch("/cart.js?timestamp=" + Date.now(), { cache: "no-store" });
    const cart = await response.json();
    
    const existingItem = cart.items.find(item => item.id === specificVariantId);

    if (existingItem) {
      if (existingItem.quantity !== 1) {
        await updateProductQuantity(existingItem.key, 1);
      }
      setTimeout(() => {
        const toggleBtnn = document.querySelector(".toggle_button_atc");
        if (toggleBtnn) toggleBtnn.classList.add("active");
      }, 1000);
    } else {
      setTimeout(() => {
        const toggleBtnn = document.querySelector(".toggle_button_atc");
        if (toggleBtnn) toggleBtnn.classList.remove("active");
      }, 1000);
    }
  } catch (error) {
    console.error("Error managing specific product:", error);
  }
 
}
async function checkAndRemoveSpecificProduct() {
  const specificVariantId = 46692864065836;

  try {
    const response = await fetch('/cart.js?timestamp=' + Date.now(), {
      cache: 'no-store'
    });
    const cart = await response.json();

    if (!cart.items || cart.items.length === 0) return;

    const specificProduct = cart.items.find(
      i => i.id === specificVariantId
    );

    if (specificProduct && cart.items.length === 1) {
      console.log("Auto-removing specific product.");

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [specificProduct.key]: 0 }
        })
      });

      document.dispatchEvent(
        new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })
      );
    }
  } catch (err) {
    console.error("Error in specific removal:", err);
  }
}

checkAndRemoveSpecificProduct();

  setInterval(initToggleButtonHandler, 7000);

 // On main Add to Cart button click → wait 2s, then add/toggle the specific product
  const addToCartBtn = document.querySelector('[name="add"]');
  addToCartBtn.addEventListener('click', async () => {
    setTimeout(async () => {
      await ensureSpecificProductInCart();
      initToggleButtonHandler();
    }, 3000);
  });
  
});
}
    

    handleSectionSelect(evt) { if (evt.target === this.closest('.shopify-section')) this.open(); }
    handleSectionDeselect(evt) { if (evt.target === this.closest('.shopify-section')) this.close(); }
    handleDrawerOpenViaEvent(evt) { this.open(evt.detail ? evt.detail.opener : null); }

    open(opener, elementToFocus) {
      const quickAddDrawer = document.querySelector('quick-add-drawer[aria-hidden="false"]');
      const overlay = document.querySelector('.js-overlay.is-visible');

      if (quickAddDrawer) {
        if (overlay) overlay.style.transitionDelay = '200ms';
        quickAddDrawer.close();
      }

      setTimeout(() => {
        super.open(opener, elementToFocus, () => {
          if (this.cartSummary.classList.contains('cart-drawer--checkout--sticky-true')) CartDrawer.recalculateCssVarHeights();
        });
        if (overlay) overlay.style.transitionDelay = '';
      }, quickAddDrawer ? 200 : 0);
    }

    async refresh(dontRefreshCartItems) {
      try {
        const cartItems = this.querySelector('cart-items');
        if (cartItems && !dontRefreshCartItems) cartItems.refresh();
        else {
          const response = this.getSectionsToRender().map(section => section.section);
          const cartResponse = await fetch(`?sections=${response.join(',')}`);
          const sections = await cartResponse.json();
          this.renderContents({ sections }, false);
          CartDrawer.recalculateCssVarHeights();
        }
      } catch (error) {
        console.log(error);
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: { error: this.errorMsg?.textContent }
        }));
      }
    }

    async renderContents(data, openDrawer = true) {
      if (!this.scriptsLoaded) {
        if (!document.querySelector(`script[src="${theme.scripts.cartItems}"]`)) await loadScript(theme.scripts.cartItems);
        if (!document.querySelector(`script[src="${theme.scripts.shippingCalculator}"]`) && this.dataset.shippingCalculator) {
          await loadScript(theme.scripts.countryProvinceSelector);
          await loadScript(theme.scripts.shippingCalculator);
        }
        this.scriptsLoaded = true;
      }

      this.getSectionsToRender().forEach((section) => {
        const el = document.getElementById(section.id);
        if (el) el.innerHTML = CartDrawer.getElementHTML(data.sections[section.section], section.selector);
      });

      if (openDrawer && this.getAttribute('open') === null) setTimeout(() => this.open());
      this.initCouponForm();
      this.initSpecificProductEvent();
    }

    getSectionsToRender() {
      return [
        { id: 'cart-drawer', section: this.closest('.shopify-section').id.replace('shopify-section-', ''), selector: 'cart-drawer' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
      ];
    }

    static recalculateCssVarHeights() {
      window.requestAnimationFrame(() => {
        document.dispatchEvent(new CustomEvent('on:css-var-height:update'));
      });
    }

    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;
      return tmpl.content.querySelector(selector).innerHTML;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}
